import { createStore } from 'vuex';

import UserInfo from './userInfo';
import DesktopMode from './desktopMode';
import Study from './study';
import Export from './export';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    UserInfo,
    DesktopMode,
    Study,
    Export,
  },
});
